export const getPhoneNumberE164 = (phoneNumber?: number): string => {
  if (!phoneNumber) {
    return "";
  }
  const phoneNumberLen11 = `${phoneNumber}`.padStart(11, " ");
  const countryCode = phoneNumberLen11.slice(0, 1);
  const areaCode = phoneNumberLen11.slice(1, 4);
  const prefix = phoneNumberLen11.slice(4, 7);
  const lineNumber = phoneNumberLen11.slice(7);
  const phoneNumberE164 = `${countryCode !== " " ? "+" + countryCode : ""} ${areaCode}-${prefix}-${lineNumber}`;
  return phoneNumberE164;
};
